// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";


// Stateful components
export class EnquiryManagement extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {};
    }


    //
    // Functions
    //

    

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
       

        return (
            <>Enquiry Management</>
        );
    }

};

EnquiryManagement.contextType = PortalContext;
